function VariablesTransformer (variables) {
    if(variables == undefined) {
        variables = {};
    }

    variables =  Object.keys(variables).map(key => {return { name : key, value : variables[key] } })
    variables = variables.sort((a,b) => a.name.localeCompare(b.name))
    return variables;
}

export default VariablesTransformer;